/* eslint-disable no-new */
import { Menubar } from "~/src/accessibility/Menubar";
import { Dropdown, initializeSimpleDropdown } from "~/src/accessibility/Dropdown";

if (document.readyState !== "loading") {
  initAccessibility();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    initAccessibility();
  });
}

function initAccessibility() {
  new Menubar(".header__right-sub-navigation", {
    icon: ".header__hamburger",
    dialog: ".header__mobile-navigation",
  });
  new Menubar(".header__left-sub-navigation");
  new Dropdown(".header__dropdown", ".header__navigation-items-container");
  initializeSimpleDropdown();
}
